<script setup lang="ts">
import ConnxButton from '@/components/Atoms/ConnxButton.vue';

const emit = defineEmits<{
  'view-more': [];
}>();
</script>

<template>
  <div>
    <connx-button button-style="blank" @click="emit('view-more')" class="tw-text-connx-primary tw-pl-0">
      View More Settings
    </connx-button>
  </div>
</template>
